/**
 * Colors used when content is rendered over a cover image.
 * Intentionally literal rather than theme tokens: they sit on top of
 * photographic covers, so they must not adapt to light/dark surfaces.
 */
export const COVER_TEXT_COLOR = "#FFFFFF";
export const COVER_TEXT_SECONDARY_COLOR = "rgba(255,255,255,0.7)";
export const COVER_PROGRESS_TRACK_COLOR = "rgba(255,255,255,0.3)";
export const COVER_BADGE_BG_COLOR = "rgba(255,255,255,0.35)";
export const COVER_SEPARATOR_COLOR = "rgba(255,255,255,0.4)";
export const COVER_BORDER_COLOR = "rgba(255,255,255,0.2)";
export const COVER_OVERLAY_COLORS = [
	"rgba(0,0,0,0.3)",
	"rgba(0,0,0,0.79)",
	"rgba(0,0,0,0.79)",
] as const;
export const COVER_OVERLAY_LOCATIONS = [0, 0.69, 1] as const;
